export const Colors = {
    appointmentCardBgColor: '#F6F6F6',
    appointmentCardBgColorOpacity6: '#f6f6f60f',
    primaryTextColor: '#161616',
    greenBorderColor: '#179D82',
    greenWithOpacity14: "#179d8224",
    grey: "#D8D8D8",
    lightGrey: "#666666",
    white: "#FFFFFF",
    primaryOrange: "#F59423",
    secondaryTextColor: '#AAAAAA',
}

export const STATUS_STYLES = {
    completed: {
        textColor: "#46CC6B",
        tagColor: "rgba(23, 157, 130, 0.14)", // 14% opacity
    },
    cancelled: {
        textColor: "#E32C04",
        tagColor: "rgba(227, 44, 4, 0.12)", // 12% opacity
    },
    ongoing: {
        textColor: "#E32C04",
        tagColor: "rgba(227, 44, 4, 0.12)", // 12% opacity
    },
    upcoming: {
        textColor: "#E32C04",
        tagColor: "rgba(227, 44, 4, 0.12)", // 12% opacity
    },
    default: {
        textColor: "#F59423",
        tagColor: "rgba(245, 148, 35, 0.12)", // 12% opacity
    },
    pending: {
        textColor: "#EA8B32",
        tagColor: "rgba(245, 148, 35, 0.12)", // 12% opacity
    },

};